; (function () {
const videoswipers = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  $('.video-container').each(function () {
    const $section = $(this);
    const swipers = $section.find('.swiper');

    if (swipers.length > 0) {
      swipers.each(function () {
        const swiper = this;
        const $pagination = $(swiper).find('.pagination');
        const $next = $(swiper).find('.next');

        const swiperInstance = new Swiper(swiper, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          speed: 300,
          pagination: {
            el: $pagination[0],
            clickable: true,
          },
          navigation: {
            nextEl: $next[0],
          },
        });

        const $videos = $(swiper).find('video');

        function pauseAllVideos() {
          $videos.each(function () {
            this.pause();
            this.currentTime = 0;
          });
        }

        function playCurrentVideo() {
          const currentSlide = swiperInstance.slides[swiperInstance.activeIndex];
          if (!currentSlide) return;

            if (isMobile) {
             const video = currentSlide.querySelector('.hide_desktop video');
              console.log(video)
              video.play().catch(err => {
                console.warn("Mobile autoplay failed", err);
              });
              video.onended = () => {
                swiperInstance.slideNext();
              };
            }else{
             const video = currentSlide.querySelector('.hide_mobile video');
              video.play().catch(err => {
                console.warn("Mobile autoplay failed", err);
              });
              video.onended = () => {
                swiperInstance.slideNext();
              };
            }
        }

        // 播放第一个视频
        playCurrentVideo();

        // 切换幻灯片时播放当前视频
        swiperInstance.on('slideChange', () => {
          pauseAllVideos();
          setTimeout(playCurrentVideo, 300); // 适当延迟，确保 DOM 准备好了
        });
      });
    }
  });
};


  document.addEventListener('DOMContentLoaded', function () {
    videoswipers();

    document.addEventListener('shopify:section:load', function () {
      videoswipers();
    });
  });
})();